import { Star } from 'lucide-react';
import type { Event } from '@casetrace/shared';
import type { ToggleHighlightHandler } from '../../../hooks/use-toggle-highlight';

const STAR_COLOR = '#f5b301';

interface EventStarButtonProps {
  event: Event;
  isHighlighted: boolean;
  canToggleHighlight: boolean;
  onToggleHighlight: ToggleHighlightHandler;
}

export function EventStarButton({
  event,
  isHighlighted,
  canToggleHighlight,
  onToggleHighlight,
}: EventStarButtonProps) {
  const starLabel = isHighlighted ? 'Fjern relevant-merking' : 'Marker som relevant';

  return (
    <button
      type="button"
      className={`absolute right-2 top-2.5 z-[1] rounded p-0.5 transition-opacity duration-150 ${
        isHighlighted ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
      } ${canToggleHighlight ? 'hover:bg-white/10' : 'cursor-not-allowed'}`}
      aria-pressed={isHighlighted}
      aria-label={starLabel}
      title={canToggleHighlight ? starLabel : 'Kun eier og medlemmer kan markere som relevant'}
      disabled={!canToggleHighlight}
      onClick={(clickEvent) => {
        clickEvent.stopPropagation();
        if (canToggleHighlight) onToggleHighlight(event, isHighlighted);
      }}
    >
      <Star
        size={16}
        style={{ color: isHighlighted ? STAR_COLOR : 'rgba(255,255,255,0.45)' }}
        fill={isHighlighted ? STAR_COLOR : 'none'}
      />
    </button>
  );
}
